import React, { useRef } from "react";
import { MentionsInput, Mention } from "react-mentions";
import api from "../Api";

export default function OperatorMentionInput({ value, onChange }) {
  const timeoutRef = useRef(null);

  const fetchUsers = (query, callback) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(async () => {
      try {
        const response = await api.get("/user/mention", {
          params: { search: query },
        });
        const formatted = response.data.map((user) => ({
          id: user.id,
          display: user.display,
        }));
        callback(formatted);
      } catch (error) {
        console.error("Errore nel fetch utenti:", error);
        callback([]);
      }
    }, 300);
  };

  return (
    <div className="w-full">
      <label className="block font-medium text-green-500 mb-2">Operatore</label>
      <MentionsInput
        value={value}
        onChange={(event, newValue, newPlainTextValue, mentions) => {
          onChange(newValue);
        }}
        className="w-full border  rounded bg-primary border-secondary focus:outline-none focus:ring-2 focus:ring-secondary text-white"
        style={{
          control: {
            backgroundColor: "transparent",
            color: "white",
            borderRadius: "0.375rem",
            outline: "none",
            boxShadow: "none",
            padding: "4px"
          },
          input: {
            color: "white",
            outline: "none",
            boxShadow: "none",
            padding: "4px"
          },
          highlighter: {
            overflow: "hidden",
          },
          suggestions: {
            backgroundColor: "#1f2937",
            color: "white",
            borderRadius: "0.375rem",
            zIndex: 100,
          },
        }}
      >
        <Mention
          trigger="@"
          data={fetchUsers}
          // Restituisce solo il nome, senza il simbolo "@"
          displayTransform={(id, display) => `${display}`}
          // Usa il markup predefinito per garantire il corretto funzionamento
          markup="@[__display__](__id__)"
          renderSuggestion={(suggestion, search, highlightedDisplay, index, focused) => (
            <div
              style={{
                padding: "5px",
                borderRadius: "0.375rem",
                backgroundColor: focused ? "#575757" : "transparent",
              }}
            >
              {highlightedDisplay}
            </div>
          )}
        />
      </MentionsInput>
    </div>
  );
}
